import type { FC } from "react";
import React, { memo } from "react";
import Button from "../../../../shared-components/css-modules/toyota/atoms/Button";
import styles from "../common/navigation/Navigation.module.scss";
import Icon from "../../../../shared-components/css-modules/toyota/atoms/Icon";
import { CarConfigHighlightSection } from "../../../utils/types/SectionTypes";
import { useCarConfigSelector } from "../../../redux/store";
import { CarConfigLabel } from "../../../utils/labelUtils";

export type HighlightsHeroButtonProps = {
    handleClick: (target: CarConfigHighlightSection) => void;
};

const HighlightsHeroButton: FC<HighlightsHeroButtonProps> = ({ handleClick }) => {
    const sectionIsActive = useCarConfigSelector(
        (state) => state.carConfigNavigation.activeSection === CarConfigHighlightSection.SectionHeader,
    );

    return (
        <li>
            <Button
                href={`#${CarConfigHighlightSection.SectionHeader}`}
                variant="clean"
                className={`${styles["nav-link"]} ${styles["nav-link-top"]} ${
                    sectionIsActive ? ` ${styles.active}` : ""
                }`}
                onClick={(event) => {
                    event.preventDefault();
                    handleClick(CarConfigHighlightSection.SectionHeader);
                }}
            >
                <Icon variant="grid" className={styles.topicon} aria-hidden="true" />

                <CarConfigLabel label="carConfigHighlightsOverview" />
            </Button>
        </li>
    );
};

export default memo(HighlightsHeroButton);
